import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ChatPage from './pages/ChatPage'; // Import our new container page

function App() {
  return (
    <Routes>
      <Route path="/:brandName" element={<ChatPage />} />
      <Route path="/" element={<ChatPage />} />
    </Routes>

  );
}

export default App;